export const Svgs = [
	{
		"name" : "welcome",
		"path" : "welcome.svg"
	},
	{
		"name" : "getting_started",
		"path" : "getting_started.svg"
	}
];